<template>
  <div
    class="main-box text-center"
    :class="{ 'main-box-success': success, 'main-box-danger': danger }"
  >
    <span>{{ title }}</span>
  </div>
</template>

<script>
export default {
  name: 'ServiceStatusBadge',
  props: {
    title: {
      type: String,
      required: true,
    },
    success: {
      type: Boolean,
      default: () => false,
    },

    danger: {
      type: Boolean,
      default: () => false,
    },
  },
};
</script>

<style scoped>
.main-box {
  background: #ffeebb 0% 0% no-repeat padding-box;
  border-radius: 25px;
  opacity: 1;
  padding: 8px;
  width: 210px;
}

.main-box-success {
  background: #a3e5b3 0% 0% no-repeat padding-box;
  border-radius: 25px;
  opacity: 1;
}

.main-box-danger {
  background: #fcc9c8 0% 0% no-repeat padding-box;
  border-radius: 25px;
  opacity: 1;
}

.main-box span {
  text-align: left;
  font: Bold 16px/19px Lato;
  letter-spacing: 0;
  color: #11291b;
  opacity: 1;
}
</style>
